import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ViolationTypeListPage" */
	'pages/vehicle/ViolationType/ViolationTypeListPage'));

export default [{ component, exact: true, path: '/violation_types' }];